var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9062 3.46094L10.6562 5.71094C10.4688 5.89844 10.1641 5.75781 10.1641 5.52344V3.8125H1.28125C1.11719 3.8125 1 3.69531 1 3.53125V2.96875C1 2.82812 1.11719 2.6875 1.28125 2.6875H10.1641V1C10.1641 0.765625 10.4688 0.625 10.6562 0.8125L12.9062 3.0625C13.0234 3.17969 13.0234 3.34375 12.9062 3.46094ZM1.07031 7.96094C0.953125 7.84375 0.953125 7.67969 1.07031 7.5625L3.32031 5.3125C3.50781 5.125 3.8125 5.26562 3.8125 5.5V7.1875H12.7188C12.8594 7.1875 13 7.32812 13 7.46875V8.03125C13 8.19531 12.8594 8.3125 12.7188 8.3125H3.8125V10.0234C3.8125 10.2578 3.50781 10.3984 3.32031 10.2109L1.07031 7.96094Z",
    fill: "#C5C5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "static/media/transferIcon.5419e3f577337a51d7ad5099847bf767.svg";
export { ForwardRef as ReactComponent };